import React from 'react';
import PropTypes from 'prop-types';
import s from './TestStatus.module.scss';
import { LID_STATUSES } from '../../../../constants/enums';
import success from '../../../assets/successStatus.svg';
import failed from '../../../assets/failedStatus.svg';
import almost from '../../../assets/almostStatus.svg';

interface TestStatusProps {
  isPassed: boolean;
  isLid: boolean;
  customText?: string;
  percentage?: number;
}

function TestStatus({
  isPassed,
  isLid,
  customText,
  percentage,
}: TestStatusProps) {
  let status: 'success' | 'almost' | 'failed' = 'failed';
  let statusIcon = '';
  let statusText = '';

  if (isPassed) {
    status = 'success';
    statusIcon = success;
    statusText = isLid ? LID_STATUSES.MET : 'Pre-qualified';
  } else if (
    percentage !== undefined &&
    isLid &&
    percentage >= 45 &&
    percentage <= 51
  ) {
    status = 'almost';
    statusIcon = almost;
    statusText = LID_STATUSES.CLOSE; // Assuming LID_STATUSES is imported from the correct module
  } else if (
    percentage !== undefined &&
    !isLid &&
    percentage > 50 &&
    percentage < 60
  ) {
    status = 'almost';
    statusIcon = almost;
    statusText = 'Close to meeting CDFI status';
  } else {
    status = 'failed';
    statusIcon = failed;
    statusText = isLid ? LID_STATUSES.NOT_MET : 'CDFI status not met';
  }

  return (
    <div className={`${s.statusElement} ${s[status]}`}>
      <div className={`${s.statusElement__text}`}>
        <img src={statusIcon} alt="status" />
        <span className={`${s.statusElement__text__status}`}>
          {customText || statusText}
        </span>
      </div>
    </div>
  );
}

TestStatus.propTypes = {
  isPassed: PropTypes.bool.isRequired,
  isLid: PropTypes.bool.isRequired,
  customText: PropTypes.string,
  percentage: PropTypes.number,
};

TestStatus.defaultProps = {
  customText: undefined,
  percentage: undefined,
};

export default TestStatus;
